import { render, staticRenderFns } from "./SmsDialog.vue?vue&type=template&id=37e4b6dd&scoped=true&"
import script from "./SmsDialog.vue?vue&type=script&lang=js&"
export * from "./SmsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e4b6dd",
  null
  
)

export default component.exports